<template>

    <Head title="Ubah Data Kunjungan" />
    <div class="card card-outline card-primary">
        <div class="card-header">
            <h1 class="card-title">UBAH DATA KUNJUNGAN</h1>
            <div class="card-tools">
                <Link class="btn btn-tool" href="/kunjungan">
                <i class="fas fa-times"></i>
                </Link>
            </div>
        </div>
        <form @submit.prevent="submit">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="row">
                            <div class="col-sm">
                                <input-text label="Rekening" v-model="form.rek" readonly />
                            </div>
                            <div class="col-sm">
                                <input-text label="Macet" v-model="form.bln_tung" readonly />
                            </div>
                        </div>
                        <input-text label="Nama" v-model="form.nama" readonly />
                        <text-area label="Alamat" v-model="form.alamat" readonly />
                        <div class="row">
                            <div class="col-sm">
                                <input-text label="Titipan" v-model="form.titipan" readonly />
                            </div>
                            <div class="col-sm">
                                <input-text label="Tunggakan" v-model="form.tunggakan" readonly />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm">
                                <input-text label="Masa Angsuran" v-model="form.masa_angsuran" readonly />
                            </div>
                            <div class="col-sm">
                                <input-text label="Angsuran" v-model="form.angsuran" readonly />
                            </div>
                        </div>
                        <text-area label="Jaminan" v-model="form.jaminan" readonly />
                        <div class="row">
                            <div class="col-sm">
                                <datepicker label="Tanggal Kunjungan" v-model="form.tgl_kunj"
                                    class="fas fa-calendar-alt" disabled />
                            </div>
                            <div class="col-sm">
                                <datescope label="Tanggal Janji" v-model="form.tgl_janji" :error="form.errors.tgl_janji"
                                    class="fas fa-calendar-alt" />
                            </div>
                        </div>
                        <text-area label="Keterangan" v-model="form.keterangan" :error="form.errors.keterangan" />
                    </div>
                    <div class="col-sm-6">
                        <file-pond name="imageFilepond" ref="pond" :allow-multiple="true" max-files="2"
                            accepted-file-types="image/png, image/jpeg"
                            label-idle="Letakkan gambar disini, atau <span class='filepond--label-action'>jelajahi</span>"
                            :server="{
                                url: '',
                                timeout: 7000,
                                process: {
                                    url: '/upload',
                                    method: 'POST',
                                    headers: {
                                        'X-CSRF-TOKEN': $page.props.csrf
                                    },
                                    withCredentials: false,
                                    onload: handleFilePondLoad,
                                    onerror: () => { }
                                },
                                remove: handleFilePondRemove,
                                revert: handleFilePondRevert
                            }" :files="myFiles" @init="handleFilePondInit" imagePreviewHeight="260"
                            imageResizeMode="force" imageResizeTargetWidth="600" imageResizeTargetHeight="800"
                            styleLoadIndicatorPosition="right bottom" styleProgressIndicatorPosition="right bottom"
                            styleButtonProcessItemPosition="right bottom" styleButtonRemoveItemPosition="left bottom">
                        </file-pond>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <button type="submit" class="btn btn-primary" :disabled="form.processing">Simpan</button>
            </div>
        </form>
    </div>
</template>

<script>
import { Head, Link, usePage } from '@inertiajs/vue3'
import Layout from "@/Layouts/Master"
import InputText from '@/Forms/InputText'
import InputFile from '@/Forms/InputFile'
import TextArea from '@/Forms/TextArea'
import InputSelect2 from '@/Forms/InputSelect2'
import Datescope from '@/Forms/Datescope'
import Datepicker from '@/Forms/Datepicker'

// Import Vue FilePond
import vueFilePond from 'vue-filepond';

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import FilePond plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';

// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

// Create component
const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview,
    FilePondPluginImageResize,
    FilePondPluginImageTransform,
    FilePondPluginImageCrop,
    FilePondPluginFilePoster,
);

export default {
    layout: Layout,
    components: {
        Head,
        Link,
        InputText,
        InputFile,
        TextArea,
        InputSelect2,
        Datescope,
        Datepicker,
        FilePond,
    },
    props: {
        kunjungan: Object,
        tagihan: Object,
        poster: String,
    },
    data() {
        return {
            form: this.$inertia.form({
                rek: this.kunjungan.rek,
                nama: this.tagihan.nama,
                alamat: this.tagihan.alamat,
                bln_tung: this.tagihan.bln_tung,
                titipan: this.tagihan.titipan,
                tunggakan: this.tagihan.tunggakan,
                masa_angsuran: this.tagihan.masa_angsuran,
                angsuran: this.tagihan.angsuran,
                keterangan: this.kunjungan.keterangan,
                tgl_kunj: this.kunjungan.created_at,
                tgl_janji: this.kunjungan.tgl_janji,
                jaminan: this.tagihan.jaminan,
                image: this.kunjungan.picture,
                _method: 'patch',
            }),
            myFiles: [],
        }
    },
    methods: {
        submit() {
            this.form.post('/kunjungan/' + this.kunjungan.id, {
                forceFormData: true,
                preserveScroll: true,
                onSuccess: () => {
                    toastr.success('Ubah Kunjungan berhasil', 'SUKSES')
                }
            })
        },
        handleFilePondInit() {
            this.myFiles = [];
            let arr = this.poster ? this.poster.split('|') : [];
            for (let i = 0; i < arr.length; i++) {
                if (arr[i]) {
                    const basename = arr[i].split('/').pop();
                    this.myFiles.push({
                        source: basename,
                        options: {
                            type: 'local',
                            metadata: {
                                poster: arr[i]
                            }
                        }
                    });
                }
            }
        },
        handleFilePondLoad(response) {
            this.addFormImage(response);
            return response;
        },
        handleFilePondRemove(source, load, error) {
            this.removeFormImage(source);
            load();
        },
        handleFilePondRevert(uniqueId, load, error) {
            this.removeFormImage(uniqueId);
            this.$inertia.post('/revert', {
                image: uniqueId
            });
            load();
        },
        addFormImage(image) {
            let arr = this.form.image ? this.form.image.split('|') : [];
            arr.push(image);
            this.form.image = arr.join('|');
            console.log(this.form.image);
        },
        removeFormImage(image) {
            let arr = this.form.image ? this.form.image.split('|') : [];
            arr.remove(image.split('?')[0]);
            this.form.image = arr.join('|');
            console.log(this.form.image);
        },
    },
}

function basename(path) {
    return path.split('/').reverse()[0];
}

Array.prototype.remove = function () {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};
</script>